import React from 'react';

const IeltsIcon = () => {
  return (
    <svg
      width="92"
      height="45"
      viewBox="0 0 92 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="91.9403"
        height="44"
        transform="translate(0.0293274 0.864838)"
        fill="#D42525"
      />
      <path
        d="M70.2813 13.3961C74.3563 13.393 77.4693 15.3901 77.5244 19.567L73.1192 19.5064C73.0992 17.0436 70.3737 17.0354 70.0362 17.0309C68.265 16.9728 67.3886 17.9309 67.4307 18.6978C67.448 20.1565 69.2394 20.5521 70.9922 21.1129C74.2853 22.1586 78.1494 22.7826 78.1709 27.192C78.137 28.9493 77.6526 30.2482 76.1826 31.4254C75.0477 32.3121 73.1194 32.9755 70.5371 32.9889C67.2619 33.0105 66.1505 32.5469 64.7364 31.4459C63.3224 30.3449 62.6648 28.5902 62.5469 26.3551L67.0215 26.3551C67.2202 28.6555 68.4963 29.5497 70.6358 29.5367C72.2994 29.5317 73.7921 29.1377 73.6162 27.4654C73.5001 25.7243 70.8578 26.0098 67.4287 24.5582C65.0263 23.8431 62.7253 21.9355 62.9239 18.9586C63.2267 14.9115 66.8658 13.4112 70.2813 13.3961ZM18.5205 32.6978H13.7461V14.1939L18.5205 14.1939V32.6978ZM34.8018 17.9596L25.1778 17.9596V21.4264L34.8018 21.4264L34.8018 25.0982L25.1778 25.0982V28.8941L34.8018 28.8941V32.6978H20.5401V14.1939H34.8018V17.9596ZM41.3526 28.7223H50.044L50.044 32.6978H36.6387V14.1939H41.3526L41.3526 28.7223ZM61.9483 17.9596H56.6241V32.6978H51.9278V17.9596H46.583V14.1939L61.9483 14.1939V17.9596ZM78.1075 14.5103L77.4864 14.5103L77.4864 16.3463L77.0625 16.3463V14.5103H76.4405V14.1373L78.1075 14.1373V14.5103ZM79.3907 15.6441L79.7666 14.1373H80.4014L80.4014 16.3463H80.0088V14.607L79.5918 16.3463H79.1846L78.7696 14.607V16.3463H78.376L78.376 14.1373H79.0098L79.3907 15.6441Z"
        fill="white"
      />
    </svg>
  );
};

export default IeltsIcon;
